import React from "react";

export default function Loader() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "linear-gradient(to bottom, #0f172a, #1e293b)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        color: "white",
        fontFamily: "sans-serif",
      }}
    >
      {/* LOGO */}
      <img
        src="/IP_DEPOT_Optimizado.png"
        alt="Logo"
        style={{
          width: 140,
          marginBottom: 30,
          filter: "drop-shadow(0 0 10px #1d4ed8)",
        }}
      />

      {/* LOADING ANIMATION */}
      <div className="lds-ring">
        <div></div><div></div><div></div><div></div>
      </div>

      <p style={{ marginTop: 20, fontSize: 14, opacity: 0.8 }}>
        Cargando sistema...
      </p>

      {/* ANIMATION CSS */}
      <style>
        {`
          .lds-ring {
            display: inline-block;
            position: relative;
            width: 80px;
            height: 80px;
          }
          .lds-ring div {
            box-sizing: border-box;
            display: block;
            position: absolute;
            width: 64px;
            height: 64px;
            margin: 8px;
            border: 6px solid #3b82f6;
            border-radius: 50%;
            animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
            border-color: #3b82f6 transparent transparent transparent;
          }
          .lds-ring div:nth-child(1) {
            animation-delay: -0.45s;
          }
          .lds-ring div:nth-child(2) {
            animation-delay: -0.3s;
          }
          .lds-ring div:nth-child(3) {
            animation-delay: -0.15s;
          }
          @keyframes lds-ring {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
}
